export default __webpack_public_path__ + "static/Edvita Kelley-Smith-fd620b2383d1cffe0a837ad261fb9c54.jpg";